import angular from "angular";
import once from 'lodash/once';

import './app';
import './index'

console.log('__backendUrl__', process.env.__backendUrl__)

const bootstrap = once(() => angular.bootstrap(document, [ 'skykitProvisioning' ], {
  strictDi: true
}));
angular.element(document).ready(() => {
  bootstrap();
  // const loader = document.getElementById('loading-angular');
  // if (loader) {
  //     loader.parentNode.removeChild(loader);
  // }
});